/** Shared CLIV portal auth bootstrap helpers (bi-portal, supplier-portal). */

export interface PersistedAuthStore {
  persist: {
    hasHydrated(): boolean;
    onFinishHydration(callback: () => void): () => void;
  };
}

export function getInitialUrlHadB2CIdToken(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const raw = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  return new URLSearchParams(raw).has('id_token');
}

export function getInitialB2CIdToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const raw = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  return new URLSearchParams(raw).get('id_token');
}

export const initialB2CIdToken = getInitialB2CIdToken();

export function clearUrlHash(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
}

export function waitForAuthStoreHydration(store: PersistedAuthStore): Promise<void> {
  return new Promise((resolve) => {
    if (store.persist.hasHydrated()) {
      resolve();
      return;
    }
    const unsub = store.persist.onFinishHydration(() => {
      unsub();
      resolve();
    });
  });
}
